/**
 * Referral code mapping for traffic attribution.
 *
 * Usage: append ?r=<code> to any URL shared on a channel.
 * Example: /jobs/apply/abc123?r=wag1
 *
 * PostHog will capture these as properties on all events for that session.
 * Add new codes here as you create new distribution channels.
 */
const REFERRAL_CODES = {
  // WhatsApp groups
  wac1: { source: 'whatsapp', medium: 'social', campaign: 'whatsapp_channel_sydney_jobs' },
  wag1: { source: 'whatsapp', medium: 'social', campaign: 'whatsapp_group_labourando1' },
  wag2: { source: 'whatsapp', medium: 'social', campaign: 'whatsapp_group_labourando2' },
  wag3: { source: 'whatsapp', medium: 'social', campaign: 'whatsapp_group_labourando3' },
  wag4: { source: 'whatsapp', medium: 'social', campaign: 'whatsapp_group_labourando4' },
  wag5: { source: 'whatsapp', medium: 'social', campaign: 'whatsapp_group_labourando5' },
  wag6: { source: 'whatsapp', medium: 'social', campaign: 'whatsapp_group_labourando6' },
  wag7: { source: 'whatsapp', medium: 'social', campaign: 'whatsapp_group_labourando7' },
  wag8: { source: 'whatsapp', medium: 'social', campaign: 'whatsapp_group_labourando8' },
  wag9: { source: 'whatsapp', medium: 'social', campaign: 'whatsapp_group_labourando9' },
  wag10: { source: 'whatsapp', medium: 'social', campaign: 'whatsapp_group_labourando10' },
  wag11: { source: 'whatsapp', medium: 'social', campaign: 'whatsapp_group_labourando11' },
  wag12: { source: 'whatsapp', medium: 'social', campaign: 'whatsapp_group_labourando12' },
  wag13: { source: 'whatsapp', medium: 'social', campaign: 'whatsapp_group_labourando13' },
  wag14: { source: 'whatsapp', medium: 'social', campaign: 'whatsapp_group_labourando14' },
  wag15: { source: 'whatsapp', medium: 'social', campaign: 'whatsapp_group_labourando15' },
  wag16: { source: 'whatsapp', medium: 'social', campaign: 'whatsapp_group_labourando16' },
  wag17: { source: 'whatsapp', medium: 'social', campaign: 'whatsapp_group_labourando17' },
  wag18: { source: 'whatsapp', medium: 'social', campaign: 'whatsapp_group_labourando18' },
  wag19: { source: 'whatsapp', medium: 'social', campaign: 'whatsapp_group_labourando19' },
  wag20: { source: 'whatsapp', medium: 'social', campaign: 'whatsapp_group_labourando20' },
  

  // Facebook
  fbg: { source: 'facebook', medium: 'social', campaign: 'facebook_group_jobs' },

  // Telegram
  tg1: { source: 'telegram', medium: 'social', campaign: 'tekegram_group_labourando1' },

  //Instagram
  ig: { source: 'instagram', medium: 'social', campaign: 'instagram_post' },
  
  // Email
  em: { source: 'email', medium: 'email', campaign: 'email_newsletter' },

  // QR Code
  qr: { source: 'qrcode', medium: 'offline', campaign: 'qrcode_flyer' },
 
  // Recruiter / partner referral
};

export default REFERRAL_CODES;
